export const SCREEN_NAMES = {
    ACTIONS: 'ACTIONS',
    ADD_LOGGER: 'ADD_LOGGER',
    REMOVE_LOGGER: 'REMOVE_LOGGER',
    LOGIN: 'LOGIN',
    NO_ACCESS: 'NO_ACCESS',
    DEV_INFO: 'DEV_INFO',
};
